import { Injectable } from '@angular/core';
import { BasePagedCrudService } from "../shared/crud/base-crud.service";
import { HttpClient } from "@angular/common/http";
import { CrudSettings, QueryParams } from "../shared/crud/abstractions/base-crud";
import { EnvironmentService } from '../core/environment/environment.service';
import { EditUctovyRozvrhDto, UctovyRozvrhDto } from './models/UctovyRozvrhDto';
import { lastValueFrom } from 'rxjs';
import {DialogService} from "../shared/dialog/dialog.service";

export class UctovyRozvrhCrudSettings implements CrudSettings<string, UctovyRozvrhDto> {
    baseUrl = '';
    postUrl = '';
    queryParam = 'kodUj';
    createSuffix = "CreateMany";
    deleteSuffix = undefined;
    deleteIdLocation: 'PATH' | 'QUERY' = 'QUERY';
    editSuffix = undefined;
    editMethod: 'PUT' | 'PATCH' = 'PUT';
    editIdLocation: 'PATH' | 'QUERY' = 'QUERY';
    getListSuffix = 'Vse';
    getSuffix = 'Vse';
    getIdLocation: 'PATH' | 'QUERY' = 'QUERY';
    idGetter = (entity: UctovyRozvrhDto) => entity.kodUj;

    mapper(kod: string): QueryParams {
        const dict = new Map<string, string>();
        dict.set('kodUj', kod);
        return { params: dict }
    }

    constructor(private environmentService: EnvironmentService) {
        this.baseUrl = this.environmentService.getConfig().api.pubgw + '/api/UctovyRozvrh/Ucet';
        this.postUrl = this.environmentService.getConfig().api.pubgw + '/api/Internal/UctovyRozvrh/UctovyRozvrh/Import'
    }
}

@Injectable({
    providedIn: null
})
export class UctovyRozvrhDataService

    extends BasePagedCrudService<string, UctovyRozvrhDto, UctovyRozvrhDto, EditUctovyRozvrhDto>{

    constructor(private _http: HttpClient, private environmentService: EnvironmentService, override dialogService: DialogService) {
        super(_http, new UctovyRozvrhCrudSettings(environmentService), dialogService);
    }

    override async get(params: any) : Promise<UctovyRozvrhDto> {
    let urlParams = Object.keys(params).reduce((a, c: string) => a + c + "=" + params[c] + "&", "?");
    const res$ = this._http.get<UctovyRozvrhDto>(`${this.getSettings().baseUrl}${urlParams ? urlParams : ""}`);
    let res = await lastValueFrom(res$);
    return res;
    }

    override async edit(params: any, body: EditUctovyRozvrhDto) : Promise<EditUctovyRozvrhDto> {
        params = {"kodUj": body["kodUj"], "kodUo": body["kodUo"], "su": body["su"], "au": body["au"]}
        let urlParams = Object.keys(params).reduce((a, c: string) => a + c + "=" + params[c] + "&", "?");
        const res$ = this._http.put<EditUctovyRozvrhDto>(`${this.getSettings().baseUrl}${urlParams ? urlParams : ""}`, body);
        let res = await lastValueFrom(res$);
        return res;
    }

    override async delete(params: any): Promise<void> {
        let urlParams = Object.keys(params).reduce((a, c: string) => a + c + "=" + params[c] + "&", "?");
        const res$ = this._http.delete<void>(`${this.getSettings().baseUrl}${urlParams ? urlParams : ""}`);
        let res = await lastValueFrom(res$);
        return res;
    }

    override async create<T>(params: any, body: T, useCreateManySuffix: boolean = false): Promise<T> {
        let urlParams = Object.keys(params).reduce((a, c: string) => a + c + "=" + params[c] + "&", "?");
        const res$ = this._http.post<T>(`${this.getSettings().baseUrl}${useCreateManySuffix ? `/${this.getSettings().createSuffix}` : ""}${urlParams ? urlParams : ""}`, body);
        return  await lastValueFrom(res$);
    }

    async copy(params: any) : Promise<UctovyRozvrhDto> {
        let urlParams = Object.keys(params).reduce((a, c: string) => a + c + "=" + params[c] + "&", "?");
        const res$ = this._http.post<UctovyRozvrhDto>(`${this.getSettings().baseUrl + "/PrevzitZMinulehoObdobi"}${urlParams ? urlParams : ""}`, null);
        let res = await lastValueFrom(res$);
        return res;
    }

    public async import(params: any, entity: any) {
        let a = this.getSettings();
        await this.action(params, entity, a.postUrl!);
      }
}
